/**
 * The install suggestion, rendered.
 *
 * A line and a button on a screen someone is already finished with. Never a modal, never in the
 * way, and never a second time.
 */

import { el } from '../lib/dom';
import { installOffer, noteInstallOffered } from '../lib/install';

/** Returns the element to slot into the success screen, or null if there is nothing to offer. */
export function installSuggestion(): HTMLElement | null {
  const offer = installOffer();
  if (!offer) return null;

  noteInstallOffered();

  if (offer.kind === 'instructions') {
    return el('div', { class: 'install' }, el('p', { class: 'install__text', text: offer.text }));
  }

  const button = el(
    'button',
    { class: 'button button--ghost button--small', type: 'button' },
    'Add to home screen',
  );

  const wrapper = el(
    'div',
    { class: 'install' },
    el('p', { class: 'install__text', text: 'Next time, skip the browser.' }),
    button,
  );

  button.addEventListener('click', () => {
    button.setAttribute('disabled', '');
    void offer.accept().finally(() => wrapper.remove());
  });

  return wrapper;
}
